import { AssetTypeClassification } from "src/shared/service-proxies/service-proxies";

export class VehicleTypeHelper {
    static ConvertVehicleTypeNameToAssetTypeClassification(vehicleType: string): AssetTypeClassification {
        if (vehicleType == 'RoRo') {
            return AssetTypeClassification.RoRo
          }
      
          return AssetTypeClassification.Skip;
    }
}